import styled, { keyframes } from "styled-components";

import Backdrop from "components/global/Backdrop";

export const AllPostsWrapper = styled.div`
  padding: 24px;

  .stickyTop {
    background-color: #ffffff;
    top: 7.2rem;
    z-index: 3;
  }

  .btn-container {
    position: relative;

    button {
      &:disabled:hover ~ .info {
        display: block;
      }
    }

    .info {
      width: 224px;
      position: absolute;
      background: var(--background);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
        0px 25px 35px rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      font-weight: 450;
      font-size: 14px;
      line-height: 18px;
      padding: 8px;
      right: 0;
      display: none;
      z-index: 4;
    }
  }

  .newPost {
    height: 4.8rem;
    border-radius: 0.8rem;
    background-color: var(--primary);
    padding: 0 2.4rem;
    transition: all 0.2s ease-out;
    gap: 1.2rem;

    &:hover {
      background-color: var(--primary_light);
    }
  }

  @media screen and (max-width: 768px) {
    .noPost {
      button {
        width: 100%;
      }

      .description {
        width: 100%;
      }
    }

    .newPost {
      position: fixed;
      bottom: 64px;
      right: 24px;
      z-index: 2;
      border-radius: 50%;
      height: 56px;
      width: 56px;
      padding: 0;
      justify-content: center;

      span {
        display: none;
      }
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;

      &.emptyState {
        font-size: 16px;
      }
    }
  }
`;

export const AllPostsFilters = styled.div`
  flex-wrap: wrap;
  gap: 2.4rem;

  .filterItem {
    transition: color 0.2s ease-out;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      color: var(--secondary);
    }
  }

  .divider {
    height: 3.6rem;
    width: 1px;
    background-color: var(--body_text);
  }

  .filterSelect {
    padding: 1.4rem;
    border: 1px solid var(--grey_10);
    border-radius: 0.8rem;
  }

  .selectCreator {
    width: max-content;

    .inputWrapper {
      padding: 1.4rem;
      border: 1px solid var(--grey_10);
      border-radius: 0.8rem;

      input {
        font-size: 14px;
        line-height: 16px;
      }

      input::placeholder {
        color: var(--body_text);
        font-size: 14px;
        line-height: 16px;
      }
    }

    .toggleIcon {
      filter: brightness(0) saturate(0);
    }
  }

  @media screen and (max-width: 768px) {
    gap: 1.2rem;

    .filterSelect,
    .clearFilter {
      padding: 1rem 1.6rem;
      height: fit-content;
    }

    .dateFilterWrapper {
      margin-left: auto;
    }
  }
`;

export const AllPostsPostGroup = styled.div`
  padding: 2.4rem 0;
`;

export const Tab = styled.div`
  background-color: #ffffff;
  border-bottom: 1px solid var(--grey_10);
  gap: 48px;

  .item {
    position: relative;
    padding-bottom: 1.2rem;
    cursor: pointer;

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      height: 3px;
      border-radius: 3px;
      width: 100%;
      background-color: var(--secondary);
      opacity: 0;
      transition: opacity 0.2s ease-out;
    }

    &.active {
      .icon {
        filter: var(--filter_primary);
      }

      span {
        color: var(--primary);
        font-weight: 700;
      }

      &::after {
        opacity: 1;
      }
      .count-tag {
        color: #fff;
      }
    }

    .count-tag {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 3px;
      background: #fd0403;
      color: #fff;
      font-weight: 700;
      font-size: 12px;
    }
  }

  @media screen and (max-width: 768px) {
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .item {
      border: 1px solid #fff;
      padding-right: 0;

      span {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
`;

export const CreatePostWrapper = styled.div`
  /* display: grid;
  grid-template-columns: 5fr 3fr; */
  height: calc(100vh - 72px);
  overflow: hidden;
  position: relative;
  display: flex;

  .draft-contentWrapper {
    border-right: 1px solid var(--grey_10);
    height: 100%;
    overflow: auto;
    width: 63%;

    .main-content {
      padding: 24px 48px 96px;
    }
  }

  .contentWrapper {
    padding: 24px 48px 96px;
    border-right: 1px solid var(--grey_10);
    height: 100%;
    overflow: auto;
    width: 63%;
  }

  .characterCount {
    position: absolute;
    right: 0;
    top: 0;
    color: var(--body_text);
    line-height: 20px;
  }

  .mb {
    display: none;
  }

  .draft-preview {
    background: var(--background);
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;

    .draft-contentWrapper {
      width: 100%;

      .main-content {
        padding: 48px 24px 96px;
      }
    }

    .contentWrapper {
      padding: 48px 24px 96px;
      width: 100%;
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }

    .mb {
      display: block;
    }

    .actionBtns {
      button {
        width: calc(50% - 0.6rem);
      }
    }

    .lg {
      display: none;
    }
  }
`;

export const CharacterLimitsWrapper = styled(Backdrop)`
  padding: 4.8rem;

  .card {
    width: 46.8rem;
    padding: 4.8rem;
    background-color: var(--white);
    border-radius: 0.8rem;
  }

  .socialIcon {
    height: 3.6rem;
  }

  .socialRow {
    margin-bottom: 1.2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 2.4rem;

    .card {
      width: 100%;
      padding: 4.8rem 2.4rem;
    }

    .title {
      font-size: 18px;
      line-height: 20px;
    }

    .description {
      font-size: 14px;
      line-height: 20px;
    }

    .socialIcon {
      height: 2.4rem;
    }
  }
`;

export const Attachments = styled.div`
  display: grid;

  .fileInput {
    display: none;
  }

  .chooseMedia {
    margin-right: 1.2rem;

    .icon {
      height: 12rem;
    }

    &:hover {
      .icon {
        filter: var(--filter_secondary);
      }
    }
  }

  .attached {
    margin: 0 16px;
    overflow: ${({ isTiktok }) => (isTiktok ? "visible" : "auto")};
    padding-bottom: 0.6rem;

    &::-webkit-scrollbar {
      display: initial;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--background);
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb {
      background: var(--grey_5);
      border-radius: 100px;
    }

    .item {
      height: 12rem;
      aspect-ratio: 1/1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 0.3rem;
      overflow: hidden;
      background-color: var(--grey_1);
      margin-right: 1.2rem;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      .media {
        pointer-events: none;
        height: 100%;
        width: 100%;
        object-fit: contain;
      }

      .indicator {
        position: absolute;
        height: 2.4rem;
        aspect-ratio: 1/1;
        box-shadow: 0px 0px 3px var(--grey_9);
        transition: all 0.2s ease-out;
        z-index: 2;
      }

      .indicator.remove {
        top: 6px;
        right: 6px;
        opacity: 0;
        background-color: var(--danger);
      }

      .indicator.move {
        bottom: 6px;
        left: 6px;
        pointer-events: none;
        opacity: 0;
      }

      .indicator.index {
        bottom: 6px;
        right: 6px;
        pointer-events: none;
      }

      .indicator .icon {
        height: 60%;
      }

      video {
        height: 100%;
        aspect-ratio: 1/1;
      }

      .loader {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.3);
        display: none;
        // pointer-events: none;
      }

      .retryBtn {
        gap: 6px;
        padding: 6px;
        border-radius: 8px;
        background-color: #ffffff;
      }

      &[data-loaded="false"] {
        .loader {
          display: flex;
        }

        .index {
          display: none;
        }
      }

      &:hover .indicator.move,
      &:hover .indicator.remove {
        opacity: 1;
      }
    }
  }
`;

export const Socials = styled.div`
  display: flex;
  gap: 24px;

  .platformWrapper {
    position: relative;
    gap: 6px;
    height: 48px;

    .platformCheckIcon {
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
    }

    .check {
      height: 2.4rem;
      opacity: 0;
      pointer-events: none;

      &.show {
        opacity: 1;
        pointer-events: all;
      }
    }

    .platformBtn {
      height: 36px;
      width: 36px;

      .platformImg {
        height: 1.6rem;
        width: 1.6rem;
        left: 2.4rem;
      }

      &:hover {
        box-shadow: 0px 0px 5px var(--grey_9);
      }

      &:disabled {
        pointer-events: none;
        opacity: 0.4;
      }
    }
  }

  .selectPostType {
    gap: 3px;
    background-color: var(--off_white);
    border-radius: 8px;
    padding: 3px 6px;
    height: max-content;
  }

  .postTypeOptions {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    box-shadow: var(--shadow);
    border-radius: 8px;
    background-color: #ffffff;
    z-index: 30;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    &.show {
      opacity: 1;
      pointer-events: all;
    }

    .option {
      width: 100%;
      padding: 12px;
      transition: all 0.2s ease-out;

      &:hover {
        background-color: var(--background);
      }
    }
  }

  .selectAccountsDropdown {
    position: absolute;
    top: calc(100% + 12px);
    left: 0;
    z-index: 30;
    background-color: var(--white);
    box-shadow: var(--shadow);
    border-radius: 0.8rem;
    padding-top: 12px;
    width: 250px;
    max-height: 312px;
    overflow: auto;
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-out;

    .dropdownTitle {
      margin-left: 12px;
    }

    .doneBtnWrapper {
      position: sticky;
      bottom: 0;
      padding: 12px;
    }

    .doneBtn {
      height: 4.8rem;
      margin-left: auto;
    }

    .checkBox {
      padding: 12px;
      transition: all 0.2s ease-out;

      label {
        line-height: 24px;
      }

      &:hover {
        background-color: var(--background);
      }
    }

    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }

  @media screen and (max-width: 768px) {
    overflow-x: scroll;
    overflow-y: hidden;

    .selectAccountsDropdown,
    .postTypeOptions {
      max-height: 60vh;
      overflow: auto;
      position: fixed;
      bottom: unset;
      width: calc(100vw - 48px);
      margin: auto;
      left: 24px;
      top: 30vh;
    }
  }
`;

export const PreviewTab = styled.div`
  display: flex;
  gap: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 5px;

  &::-webkit-scrollbar {
    display: initial;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: var(--background);
    border-radius: 100px;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--grey_5);
    border-radius: 100px;
  }

  .item {
    height: 4.8rem;
    width: 4.8rem;

    img {
      height: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NoPostPreview = styled.div`
  width: 100%;
  max-width: 336px;

  img {
    width: 100%;
  }
`;

export const PlatformPreviewWrapper = styled.div`
  padding: 48px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const PostTitleWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 48px;
  grid-gap: 24px;
  padding: 16px;
  border-bottom: 1px solid var(--grey_10);

  input {
    display: block;
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const PostContentWrapper = styled.div`
  border: 1px solid #e2e2ea;
  border-radius: 8px;
  position: relative;
  margin-top: 24px;
  margin-bottom: 100px;
  /* overflow: auto; */

  .post-type {
    position: relative;
    border-bottom: 1px solid var(--grey_10);
    padding: 18px;
    height: 52px;
    display: flex;
    align-items: center;
    gap: 24px;

    .social-row {
      position: absolute;
      display: flex;
      gap: 6px;
      bottom: 100%;

      .platform {
        width: 32px;
        height: 30px;
        border-radius: 8px 8px 0px 0px;
        border-width: 1px;
        border-style: solid;
        border-color: #e2e2ea;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--off_white);

        &.active {
          background-color: var(--white);
        }
      }
    }

    label {
      margin-left: 0.6rem;
    }

    .radioBtn {
      height: 100%;
      aspect-ratio: 1 / 1;

      &::after {
        height: 9px;
        width: 9px;
      }
    }
  }

  .inputArea {
    padding: 16px 16px;
    border: none;
    max-height: 300px;
    overflow: auto;
    position: relative;
  }

  .noContentWarning {
    background-color: var(--warning_light);
    padding: 6px 12px;
    border-radius: 4px;
    margin-bottom: 24px;
  }

  .failedPostWarning {
    font-size: 14px;
    font-weight: 450;
    line-height: 18px;
    color: #fd0403;
    background: #ffeded;
    border-radius: 6px;
    padding: 6px 12px;
  }

  .fieldWrapper {
    height: max-content;
    display: grid;

    textarea {
      display: block;
      color: ${(props) => props.color ?? "var(--grey_1)"};
      width: 100%;
      min-height: 100px;
      background-color: transparent;
      border: none;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      position: relative;
      z-index: 2;
      overflow: hidden;
      grid-area: 1 / 1 / 2 / 2;

      &::placeholder {
        color: var(--grey_9);
      }
    }
  }

  .formattedText {
    position: relative;
    width: 100%;
    min-height: 100px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: transparent;
    white-space: pre-wrap;
    grid-area: 1 / 1 / 2 / 2;
    word-break: break-word;

    .highlighted {
      color: var(--secondary);
      position: relative;
      z-index: 3;
    }

    .extraText {
      position: absolute;
      bottom: 0;
      background-color: var(--danger_light);
      width: 100%;
    }
  }

  .action-container {
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    max-width: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 52px;
    z-index: 2;
    background-color: #ffffff;
    align-items: center;
    padding: 16px;

    .platformActions {
      gap: 24px;
    }

    .threadBtn {
      display: flex;
      gap: 3px;
      align-items: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      color: var(--secondary);
    }
  }

  .emojiBtn {
    height: 2.4rem;
    width: 2.4rem;
  }
`;

export const FileInfo = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2.4rem;
  background-color: #00000090;
  color: #ffffff;
  padding: 0.2rem 0.6rem;

  .fileName {
    width: 99%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 8px;
    line-height: 8px;
    margin-bottom: 2px;
  }

  .fileSize {
    font-size: 7px;
    line-height: 7px;
  }
`;

export const ActionCenterWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid var(--grey_10);
  border-right: 1px solid var(--grey_10);
  padding: 24px 48px;
  width: 63%;
  z-index: 5;
  background-color: #ffffff;

  .dropdown-btn {
    position: relative;
    width: 48px;
    height: 48px;

    .dropdown {
      position: absolute;
      bottom: calc(100% + 2px);
      right: 0;
      width: 196px;
      background: #fff;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
        0px 25px 35px rgba(0, 0, 0, 0.03);
      border-radius: 12px;
      padding: 12px 0;
      font-weight: 450;
      font-size: 14px;
      line-height: 18px;

      .list-item {
        padding: 13px;
        display: flex;
        align-items: center;
        gap: 9px;

        &:hover {
          cursor: pointer;
          background: var(--background);
        }

        img {
          filter: brightness(50%);
        }
      }
    }
  }

  .optionsBtn {
    background: var(--primary);
    min-width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: 250ms ease-in;

    &:not([disabled]):hover {
      background: var(--primary_light);
    }

    .caret {
      filter: invert(1);
      transform: rotate(180deg);
    }
  }

  .saveBtn {
    transition: all 0.2s ease-out;
    &:hover {
      background: inherit;
      color: var(--grey_1);
      border: 1px solid var(--grey_7);
    }
  }

  .actionBtns {
    button {
      font-size: 14px;
      font-weight: 450;
    }
  }

  .failedPost-btns {
    display: flex;
    float: right;

    .resend:hover img {
      -webkit-filter: invert(100%);
      filter: invert(100%);
    }
  }

  .scheduleTimeContainer {
    display: none;
    margin-bottom: 12px;
    .schedule-container {
      min-width: 100%;
      border-radius: 8px;
      padding: 6px;
      align-items: center;
      font-size: 12px;
      font-weight: 450;
      gap: 6px;
    }

    .scheduled {
      color: #027a48;
      background: #ecfdf3;
    }

    .unscheduled {
      background: var(--off_white);
    }

    .overdue {
      background: #ffebeb;
      color: #fd0403;
    }
  }


  @media screen and (max-width: 768px) {
    padding: 24px;
    width: 100%;
    border-right: none;
    position: fixed;

    .actionBtns {
      button {
        width: 100%;
      }
    }

    .scheduleTimeContainer {
      display: block;
    }
  }
`;

const slide = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%)translateX(-2px);
  }
`;

export const ReelPreview = styled.div`
  width: 100%;
  max-width: 336px;
  padding: 24px 12px;
  aspect-ratio: 9 / 16;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background-color: black;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--grey_10);
  border-radius: 8px;
  box-shadow: var(--shadow);

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    filter: brightness(0.8);
  }

  .reelContent {
    max-width: 253px;
    position: relative;
    pointer-events: none;
    z-index: 2;
  }

  .header {
    gap: 6px;
  }

  .audio {
    height: 28px;
    width: 120px;
    position: relative;
    display: grid;
    grid-template-columns: 16px 92px;
    grid-gap: 6px;
    align-items: center;
    border-radius: 100px;

    &[data-platform="facebook"] {
      padding: 6px 0px 6px 6px;
      background-color: rgba(255, 255, 255, 0.3);
    }

    .track {
      flex-wrap: nowrap;
      overflow: hidden;
    }
  }

  .audioTitle {
    font-size: 10px;
    animation: ${slide} 5s linear infinite;
  }

  .actionBtns {
    width: 20px;
    position: relative;
    pointer-events: none;
    z-index: 2;
    gap: 24px;

    .group {
      gap: 3px;
    }

    .profilePictureSquare {
      border-radius: 2px;
      border: 1px solid #ffffff;
    }
  }
`;

export const PreviewContainer = styled.div`
  width: 37%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--background);

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const PostBannerWrapper = styled.div`
  padding: 2.4rem;
  border: 1px solid var(--grey_10);
  border-radius: 0.8rem;
  transition: var(--transition_default);
  position: relative;
  margin-bottom: 2.4rem;
  cursor: pointer;
  background-color: var(--white);

  &:hover {
    background-color: var(--background);

    .options {
      background-color: var(--background);
    }
  }

  .captionWrapper {
    width: 50%;
  }

  .caption {
    max-width: 80%;

    .truncated {
      display: none;
    }

    .full {
      display: inline;
    }

    &.truncate {
      .truncated {
        display: inline;
      }

      .full {
        display: none;
      }
    }
  }

  .hashtags {
    max-width: 70%;
  }

  .optionBtn {
    position: relative;

    .icon {
      width: 2rem;
    }
  }

  .dateTime {
    height: max-content;
  }

  .time {
    color: #474848;
  }

  .timezone {
    max-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 2.4rem;
  }

  .status {
    gap: 4px;
    border-radius: 16px;
    padding: 2px 8px;

    .dot {
      height: 8px;
      width: 8px;
      border-radius: 100%;
    }

    &.published {
      background-color: var(--success_light);
      color: var(--success);

      .dot {
        background-color: var(--success);
      }
    }

    &.pending {
      background-color: var(--warning_light);
      color: var(--warning_dark);

      .dot {
        background-color: var(--warning);
      }
    }

    &.failed {
      background-color: var(--danger_light);
      color: var(--danger);

      .dot {
        background-color: var(--danger);
      }
    }
  }

  .socialRow {
    gap: 1.2rem;
  }

  .socialIcon {
    height: 2.4rem;
  }

  .imgWrapper {
    height: 2.4rem;
    width: 2.4rem;
    overflow: hidden;
    margin-right: 1.2rem;

    &:last-child {
      margin-right: 0;
    }

    img {
      height: 100%;
    }
  }

  .creator-container {
    gap: 6px;
    font-weight: 450;
    font-size: 12px;

    .created-title {
      color: var(--grey_6);
    }

    .creator-image {
      border-radius: 50%;
    }
  }

  .options {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    background-color: #ffffff;
    gap: 2.4rem;
    width: 100%;
    padding: 1.2rem 2.4rem;
    padding-top: 0;
    opacity: 0;
    pointer-events: none;
    transition: var(--transition_default);

    &.show {
      opacity: 1;
      pointer-events: all;
    }

    .btn {
      padding: 1.2rem 1.2rem;
      background-color: #fafafa;
      border-radius: 4px;
    }

    .deleteBtn {
      background-color: var(--danger);
    }
  }

  &.mb {
    display: none;
  }

  @media screen and (max-width: 768px) {
    padding: 1.2rem;

    .captionWrapper {
      width: 60%;
    }

    .caption {
      max-width: 100%;
      font-size: 14px;
      line-height: 18px;
    }

    .hashtags,
    .time {
      font-size: 12px;
      line-height: 16px;
    }

    .socialRow {
      gap: 3px;
    }

    .socialIcon {
      margin-left: -5px;

      &:first-child {
        margin-left: 0;
      }
    }

    .creator-container {
      gap: 14px;
    }

    .creator-image {
      border-radius: 50%;
    }

    .post-extras {
      gap: 17px;
    }

    .client {
      .clientName {
        width: 54px;
      }
    }

    &.lg {
      display: none;
    }

    &.mb {
      display: block;
    }

    .btn-text {
      display: none;
    }
  }
`;
